import { FormFieldPropertyObjectTypes, FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
const getPropertyObjectTypeValue = objectTypeId => {
  switch (objectTypeId) {
    case FormFieldPropertyObjectTypesIds.CONTACT:
      return FormFieldPropertyObjectTypes.CONTACT;
    case FormFieldPropertyObjectTypesIds.COMPANY:
      return FormFieldPropertyObjectTypes.COMPANY;
    case FormFieldPropertyObjectTypesIds.TICKET:
      return FormFieldPropertyObjectTypes.TICKET;
    case FormFieldPropertyObjectTypesIds.UNKNOWN:
      return FormFieldPropertyObjectTypes.UNKNOWN;
    default:
      return FormFieldPropertyObjectTypes.CONTACT;
  }
};
export default getPropertyObjectTypeValue;